export enum BuildersBankSocialMedia {
  YOUTUBE = 'https://www.youtube.com/channel/UCr_6OC6E_8-NDs148ntLRkw',
  FACEBOOK = 'https://www.facebook.com/buildersbank',
  INSTAGRAM = 'https://www.instagram.com/builders.bank/',
  LINKEDIN = 'https://www.linkedin.com/company/buildersbank/',
}
